import { Gauge, Droplets, Cpu, FileCode, Zap } from 'lucide-react';

// Service icons mapping
const serviceIcons = {
  'dpf_delete': Gauge,
  'adblue_delete': Droplets,
  'egr_delete': Cpu,
  'dtc_removal': FileCode,
};

const getServiceIcon = (serviceId) => {
  const IconComponent = serviceIcons[serviceId] || Zap;
  return <IconComponent className="w-6 h-6" />;
};

const PricingGrid = ({ services, onGetStarted }) => {
  return (
    <section id="pricing" className="relative py-24 bg-[#050505]">
      <div className="absolute inset-0 grid-bg opacity-20" />
      
      <div className="container mx-auto px-6 md:px-12 lg:px-24 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="text-xs font-bold tracking-[0.2em] uppercase text-[#00F0FF]">Pricing</span>
          <h2 className="font-heading text-4xl md:text-5xl font-bold tracking-tight uppercase mt-4">
            Transparent
            <span className="text-[#888]"> Pricing</span>
          </h2>
          <p className="text-[#888] mt-4">No hidden fees. Pay only for what you need.</p>
        </div>
        
        {/* Pricing Card */}
        <div className="max-w-4xl mx-auto">
          <div className="bg-[#0A0A0A] border border-white/10 overflow-hidden">
            {/* Header */}
            <div className="p-6 bg-gradient-to-r from-[#00F0FF]/20 to-[#00F0FF]/5 border-b border-white/10">
              <div className="flex items-center justify-between">
                <h3 className="font-heading text-xl font-bold uppercase tracking-wide text-white flex items-center gap-2">
                  <Zap className="w-5 h-5 text-[#00F0FF]" />
                  All Services
                </h3>
                <span className="text-[#888] text-sm uppercase tracking-wider">Prices in USD</span>
              </div>
            </div>
            
            {/* Services Grid */}
            <div className="p-6">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {services.map((service, i) => (
                  <div 
                    key={i} 
                    className="group flex justify-between items-center py-4 px-5 bg-[#1A1A1A]/50 border border-white/5 hover:border-[#00F0FF]/30 hover:bg-[#1A1A1A] transition-all"
                  >
                    <div className="flex items-center gap-4">
                      <div className="w-10 h-10 flex items-center justify-center bg-[#050505] border border-white/10 text-[#00F0FF] group-hover:border-[#00F0FF]/50 transition-colors">
                        {getServiceIcon(service.id)}
                      </div>
                      <span className="text-white text-sm font-semibold uppercase tracking-wide">{service.name}</span>
                    </div>
                    <span className="font-heading text-2xl font-bold text-[#00F0FF]">
                      ${service.base_price?.toFixed(0)}
                    </span>
                  </div>
                ))}
              </div>
            </div>
            
            {/* Footer */}
            <div className="p-4 bg-[#1A1A1A]/50 border-t border-white/10">
              <p className="text-[#888] text-xs text-center uppercase tracking-wider">
                Combo discounts available • Select multiple services during checkout for best value
              </p>
            </div>
          </div>
        </div>

        {/* CTA Button */}
        {onGetStarted && (
          <div className="text-center mt-12">
            <button 
              onClick={onGetStarted}
              className="btn-skew group relative overflow-hidden bg-[#00F0FF] text-black font-bold uppercase tracking-wider px-10 py-5 text-lg hover:bg-white hover:shadow-[0_0_40px_rgba(0,240,255,0.6)] transition-all duration-300"
              data-testid="pricing-get-started-btn"
            >
              <span className="relative z-10 flex items-center gap-2">
                Get Started
              </span>
            </button>
          </div>
        )}
      </div>
    </section>
  );
};

export default PricingGrid;
